
export default {
  methods: {
    onSubmit() {
      this.$scrollToTop();
      this.setAddressInfo();
    },

    setAddressInfo() {
      if (this.$refs.address && this.$refs.address.form) {
        this.$emit("address-info", this.$refs.address.form);
      }

      this.setSelectedCountryName();
    },

    setSelectedCountryName() {
      if (
        this.$refs.address &&
        this.$refs.address.form &&
        this.$refs.address.form.deliveryForm &&
        this.$refs.address.allowedCountries &&
        this.$refs.address.allowedCountries.length
      ) {
        var selectedCountry = this.$refs.address.form.deliveryForm.country;
        const allowedCountries = this.$refs.address.allowedCountries;

        const country = allowedCountries.filter(
          (allowedCountry) => allowedCountry.iso === selectedCountry
        );

        if (country && country[0]) {
          selectedCountry = country[0].name;
        }

        this.$emit("selected-country-name", selectedCountry);
      }
    },
  },
};
